exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  padding: 0 16px;\n}\n\nh2 {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n  margin-bottom: 0;\n  margin-top: 0.83em;\n}\n\n.action-area {\n\tposition: fixed;\n    bottom: 60px;\n    width: calc( 100% - 10px );\n}\n\n.action-area .next-btn-area {\n\tborder: 1px solid #333;\n}\n\n.action-area button {\n\twidth: 280px;\n\tmargin: 3px 0;\n}\n\n.estimate-wrapper .estimate-body {\n  overflow: scroll;\n}\n\n.blue-btn-wrapper {\n  margin: 20px;\n}\n\n.blue-btn-wrapper a {\n  border-radius: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/estimate/estimate.component.css
// module id = ../../../../../src/app/estimate/estimate.component.css
// module chunks = main